import {
  countdownDaysRemaining,
  isoDateParts,
  nextCountdownDate,
  type Countdown,
} from '@cleartask/shared';

const REPEAT_LABEL_PT: Record<Countdown['repeat'], string> = {
  none: '',
  weekly: 'toda semana',
  monthly: 'todo mês',
  yearly: 'todo ano',
};

/** 'YYYY-MM-DD' -> '25/12/2026'. */
function formatarData(date: string): string {
  const { year, month, day } = isoDateParts(date);
  return `${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/${year}`;
}

/**
 * Texto do contador.
 *
 * "Faltam -3 dias" nao e portugues, e "0 dias" nao e o que alguem quer ler no
 * dia do evento. As tres frases sao diferentes porque os tres fatos sao
 * diferentes.
 */
function frase(dias: number): string {
  if (dias === 0) return 'é hoje';
  if (dias === 1) return 'falta 1 dia';
  if (dias > 1) return `faltam ${dias} dias`;

  const passados = Math.abs(dias);
  return passados === 1 ? 'foi ontem' : `há ${passados} dias`;
}

export interface CountdownCardProps {
  countdown: Countdown;
  /** Dia civil do usuario, 'YYYY-MM-DD'. */
  today: string;
  onEdit: () => void;
  onDelete: () => void;
}

export function CountdownCard({ countdown, today, onEdit, onDelete }: CountdownCardProps) {
  // A proxima ocorrencia e DERIVADA, nunca lida de coluna: o banco guarda a
  // data alvo original, e uma coluna calculada precisaria de cron para nao
  // mentir sobre um evento anual que acabou de passar.
  const proxima = nextCountdownDate(countdown, today);
  const dias = countdownDaysRemaining(countdown, today);
  const passou = dias < 0;

  return (
    <li className="flex items-center gap-3 rounded bg-surface p-3 shadow-card">
      {countdown.icon ? (
        <span aria-hidden="true" className="text-md">
          {countdown.icon}
        </span>
      ) : null}

      <span
        aria-hidden="true"
        className="h-8 w-1 shrink-0 rounded-full"
        style={{ backgroundColor: countdown.color }}
      />

      <div className="min-w-0 flex-1">
        <p className="truncate font-medium">{countdown.title}</p>
        <p className="text-sm text-text-mut">
          {formatarData(proxima)}
          {countdown.repeat === 'none' ? '' : ` · ${REPEAT_LABEL_PT[countdown.repeat]}`}
        </p>
      </div>

      {/*
        Sem vermelho no que passou: vermelho e reservado a vencido e ao
        quadrante I (spec 7.1). Uma data que passou nao esta atrasada — ela
        simplesmente aconteceu.
      */}
      <span
        className={['shrink-0 font-mono text-sm', passou ? 'text-text-mut' : 'text-text'].join(
          ' ',
        )}
      >
        {frase(dias)}
      </span>

      {/*
        Remarcar uma data era excluir e recriar — perdendo o icone e a cor
        escolhidos, que a recriacao nao tinha como devolver. A API ja aceitava
        o PATCH desde a fase 6.
      */}
      <button
        type="button"
        onClick={onEdit}
        aria-label={`Editar ${countdown.title}`}
        className="min-h-touch shrink-0 rounded-sm px-2 text-sm text-text-mut hover:bg-surface-2"
      >
        Editar
      </button>

      <button
        type="button"
        onClick={onDelete}
        aria-label={`Excluir ${countdown.title}`}
        className="min-h-touch shrink-0 rounded-sm px-2 text-sm text-text-mut hover:bg-surface-2"
      >
        Excluir
      </button>
    </li>
  );
}
